import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import Input from "components/common/form/inputs/Input";
import If from "components/common/If";
import useAppContext from "utilities/hooks/useAppContext";
import { BookingChannelDropdownDataItemType } from "../../channel/BookingChannelDropdownInput";
import bookingUtilities from "utilities/entities/accommodation/booking-utilities";

export type BookingFormChannelModelType = {
    channel?: BookingChannelDropdownDataItemType,
    total?: number | string,
    id?: number,
    externalReference?: string,
    isCancelled?: boolean,
}

type BookingFormChannelPropsType = {
    value?: BookingFormChannelModelType,
    onChange: (value: BookingFormChannelModelType) => void
    total?: number | string
}

const BookingFormChannel = (props: BookingFormChannelPropsType) => {
    const context = useAppContext();

    const calculateChannelCommission = (force: boolean, channelData?: Partial<BookingFormChannelModelType>) => {
        let channel = {
            ...props.value,
            ...channelData,
        };
        if (props.total && (force || !props.value?.total)) {
            channel.total = bookingUtilities.calculateChannelCommission(Number(props.total)!, channel.channel!);
        }

        props.onChange({
            ...props.value,
            ...channel
        });
    }

    return (
        <fieldset>
            <If condition={props.value?.channel?.id}>
                <Input
                    label={`${context.t('fields.channel.name')} ${context.t('fields.total.name').toLowerCase()}`}
                    name="channelTotal"
                    type="number"
                    min={0}
                    placeholder={context.t('form.placeholders.leaveEmptyForDefault')}
                    onFocus={() => calculateChannelCommission(false, undefined)}
                    value={props.value?.total?.toString() || ''}
                    onChange={(value) => props.onChange({ ...props.value, total: value })}
                    suffix={{
                        icon: faCalculator,
                        name: 'calculate-channel-total',
                        title: 'common.calculate',
                        onClick: () => calculateChannelCommission(true, undefined)
                    }}
                />
            </If>
        </fieldset>
    );
};

export default BookingFormChannel;
